// Messages for operator/settings/NotificationTest — the notification testing
// sandbox (auto-merged into the i18n catalog by lib/i18n.ts).
export const en = {
  'operator.notif_test.head': 'Notification testing — Settings',
  'operator.notif_test.title': 'Notification testing',
  'operator.notif_test.desc':
    'Fire any catalog event at a customer or a staff member and watch it flow through the real pipeline (in-app inbox, email, channels & webhooks). A way to try notifications without staging a real shipment or invoice.',
  'operator.notif_test.send_title': 'Send a test',
  'operator.notif_test.send_desc':
    'Pick a recipient (a customer sends to all its portal users) and an event, then send.',
  'operator.notif_test.customer': 'Customer',
  'operator.notif_test.customer_ph': 'Search customers…',
  'operator.notif_test.staff': 'Staff member',
  'operator.notif_test.staff_none': 'None',
  'operator.notif_test.event': 'Event',
  'operator.notif_test.title_field': 'Title (optional)',
  'operator.notif_test.title_ph': 'Defaults to “Test: <event>”',
  'operator.notif_test.body_field': 'Message (optional)',
  'operator.notif_test.body_ph': 'Defaults to a generic test message',
  'operator.notif_test.send': 'Send test notification',
  'operator.notif_test.pick_recipient': 'Pick a customer and/or a staff member first.',
  'operator.notif_test.coverage': 'Event coverage',
  'operator.notif_test.coverage_desc':
    'Every catalog event and where it actually fires in the app. “Not wired” means nothing triggers it yet (you can still send it here).',
  'operator.notif_test.col_event': 'Event',
  'operator.notif_test.col_trigger': 'Fires when',
  'operator.notif_test.col_audience': 'Audience',
  'operator.notif_test.not_wired': 'Not wired',
  'operator.notif_test.audience_customer': 'Customer',
  'operator.notif_test.audience_internal': 'Internal',
}

export const zhTW = {
  'operator.notif_test.head': '通知測試 — 設定',
  'operator.notif_test.title': '通知測試',
  'operator.notif_test.desc':
    '對客戶或員工觸發任何目錄事件，並觀察它流經真實管道（站內收件匣、電子郵件、頻道與 Webhook）。無需建立實際貨件或發票即可試用通知。',
  'operator.notif_test.send_title': '傳送測試',
  'operator.notif_test.send_desc':
    '選擇收件者（選客戶會傳給其所有客戶入口使用者）與事件，然後傳送。',
  'operator.notif_test.customer': '客戶',
  'operator.notif_test.customer_ph': '搜尋客戶…',
  'operator.notif_test.staff': '員工',
  'operator.notif_test.staff_none': '無',
  'operator.notif_test.event': '事件',
  'operator.notif_test.title_field': '標題（選填）',
  'operator.notif_test.title_ph': '預設為「Test: <事件>」',
  'operator.notif_test.body_field': '訊息（選填）',
  'operator.notif_test.body_ph': '預設為一般測試訊息',
  'operator.notif_test.send': '傳送測試通知',
  'operator.notif_test.pick_recipient': '請先選擇客戶與／或員工。',
  'operator.notif_test.coverage': '事件涵蓋範圍',
  'operator.notif_test.coverage_desc':
    '所有目錄事件及其在應用程式中實際觸發的時機。「尚未接線」表示目前沒有任何動作會觸發它（您仍可在此傳送）。',
  'operator.notif_test.col_event': '事件',
  'operator.notif_test.col_trigger': '觸發時機',
  'operator.notif_test.col_audience': '對象',
  'operator.notif_test.not_wired': '尚未接線',
  'operator.notif_test.audience_customer': '客戶',
  'operator.notif_test.audience_internal': '內部',
}
